import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../../../../assets/styles/componentStyles/billingStyles/billingUsage.module.scss";

import { billingSubscriptionFeatureUsage } from "../../../../models/axiosModel";
import ConnectedChannelItem from "./connectedChannelItem";

interface connectedChannelsProps {
    connectedChannelsData?: billingSubscriptionFeatureUsage | null;
}

const ConnectedChannels = (props: connectedChannelsProps) => {
    
    const { connectedChannelsData } = props;
    
    const features = connectedChannelsData?.features || [];

    return (
        <Box className={styles.connectedChannelsCard}>
            <Box className={styles.connectedChannelsHeader}>
                <Typography className={styles.connectedChannelsTitle}>
                    Connected Channels
                </Typography>

                <Link to="/channels" target="_blank" rel="noopener noreferrer" className={styles.manageChannelsLink}>
                    Manage Channels
                </Link>
            </Box>

            {features.length > 0 ? (
                <Box className={styles.connectedChannelsContent}>
                    {features.map((feature) => (
                        <ConnectedChannelItem
                            key={feature.billing_feature_id}
                            feature={feature}
                        />
                    ))}
                </Box>
            ) : (
                <Box className={styles.channelsEmpty}>
                    <Typography>
                        No connected channels
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default ConnectedChannels;
